@if (!readonly) {
    <mat-form-field class="flex"
                    [ngClass]="{'cb-soft-required': softRequired && !required }">
        <mat-label>{{ label }}</mat-label>
        <input #trigger="matAutocompleteTrigger"
               matInput
               [name]="internalName"
               type="text"
               [(ngModel)]="value"
               [ignoreDirty]="ignoreDirty"
               [maxlength]="maxlength"
               [required]="required"
               (keyup)="onKeyUp()"
               [matAutocomplete]="auto"
               [requireMatch]="requireMatch"
               [isInvalid]="isInvalid"
               [disabled]="disabled"
               #searchInput />
        <mat-autocomplete class="flex"
                          #auto="matAutocomplete"
                          [displayWith]="displayWith"
                          (optionSelected)="handleOptionSelected($event)"
                          showPanel="true"
                          (optionsScroll)="onScroll()">
            @for (option of filteredLookups$ | async; track option; let i = $index) {
                <mat-option
                    [value]="option">
                    @if (getOptionIsStandardProduct(option)) {
                        <cb-display-pill [displayPillText]="'Standard'"></cb-display-pill>
                    }
                    <span [innerHTML]="displayWith(option) || 'Unknown'"></span>
                </mat-option>
            }
        </mat-autocomplete>
    </mat-form-field>
}
@if (readonly) {
    <div class="flex"
    >
        <cb-display-value-new class="flex"
                              [label]="label">
            {{ displayWith(value) }}
        </cb-display-value-new>
    </div>
}
